import {
    apiRequest,
    rekapSyncPresensi,
} from "../../../../../services/adapters/kepegawaian/rekapAbsensiService"

class IndexRepository {

    fetchSync = async (query) => {
        return await apiRequest("get", rekapSyncPresensi, {
            params: query
        }, true)
    }
}

export default IndexRepository